import { abortableFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

type WorkOrderGroupOperationResultDto = {
  id: string;
  success: string;
};

const unplan = async (ids: string[]) => {
  return (await abortableFetch(`${EvidenceApiUrl.WORK_ORDERS}/group/unplan`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(ids),
  }).json()) as WorkOrderGroupOperationResultDto[];
};

const unlock = async (ids: string[]) => {
  return (await abortableFetch(`${EvidenceApiUrl.WORK_ORDERS}/group/unlock`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(ids),
  }).json()) as WorkOrderGroupOperationResultDto[];
};

const lock = async (ids: string[]) => {
  return (await abortableFetch(`${EvidenceApiUrl.WORK_ORDERS}/group/lock`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(ids),
  }).json()) as WorkOrderGroupOperationResultDto[];
};

const expectedMaterial = async (ids: string[], value: boolean) => {
  return (await abortableFetch(
    `${EvidenceApiUrl.WORK_ORDERS}/group/expected-material?value=${value}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(ids),
    }
  ).json()) as WorkOrderGroupOperationResultDto[];
};

const changeState = async (ids: string[], code: string) => {
  return (await abortableFetch(
    `${EvidenceApiUrl.WORK_ORDERS}/group/change-state?code=${code}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(ids),
    }
  ).json()) as WorkOrderGroupOperationResultDto[];
};

const resync = async (ids: string[]) => {
  return await fetch(`${EvidenceApiUrl.WORK_ORDERS}/group/resync`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(ids),
  });
};

export const workOrderBulkApi = {
  unplan,
  lock,
  unlock,
  changeState,
  expectedMaterial,
  resync,
};
